module.exports = __webpack_public_path__ + "vue/img/fangda.b5076da5.png";